export enum RetValCode {
    OK = 200,
    ERROR = 400,
    NOT_FOUND = 404,
    UNAUTHORIZED = 401,
    CONFLICT = 409,
}

export default class RetVal {
    private code: RetValCode;
    private message: string;

    constructor(code: RetValCode, message: string) {
        this.setCode(code);
        this.setMessage(message);
    }

    static ok(message: string) {
        return new RetVal(RetValCode.OK, message);
    }

    static error(message: string) {
        return new RetVal(RetValCode.ERROR, message);
    }

    static notFound(message: string) {
        return new RetVal(RetValCode.NOT_FOUND, message);
    }

    static unauthorized(message: string) {
        return new RetVal(RetValCode.UNAUTHORIZED, message);
    }

    static conflict(message: string) {
        return new RetVal(RetValCode.CONFLICT, message);
    }

    setCode(code: RetValCode) {
        this.code = code;
    }

    setMessage(message: string) {
        this.message = message;
    }

    getCode() {
        return this.code;
    }

    getMessage() {
        return this.message;
    }
}

export class RetValData extends RetVal {
    private data: any;

    constructor(code: RetValCode, message: string, data: any) {
        super(code, message);
        this.setData(data);
    }

    static ok_data(message: string, data: any) {
        return new RetValData(RetValCode.OK, message, data);
    }

    static error(message: string) {
        return new RetValData(RetValCode.ERROR, message, null);
    }

    setData(data: any) {
        this.data = data;
    }

    getData() {
        return this.data;
    }
}